import * as z from 'zod';

export const SourceSchema = z.enum([
  'nameplate',
  'drawing',
  'past_report',
  'site_contact',
  'flue_gas_analyzer',
  'guess',
]);
export type Source = z.infer<typeof SourceSchema>;
